exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image[data-v-6e05a1a0]{padding-top:100%;position:relative}.image img[data-v-6e05a1a0]{max-width:100%;max-height:100%;margin:auto;position:absolute;top:0;left:0;bottom:0;right:0}", ""]);

// exports
